import { jubcss } from '../../helpers/jub-css';

export const attributeJub = jubcss(`
  .strong-wv {
    font-weight: 600 !important;
  }

  label: attribute;
`);
